import React from 'react';
import styled from 'styled-components';
import theme from '^/theme';
import RequestTitleIcon from '^/assets/icons/photo-request/request-title.svg';
interface RequestIconProps {
  testId?: string;
}

const IconWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '20px',
  height: '20px',
  color: theme.colors.neutralBlue[500],
});

export const RequestIcon: React.FC<RequestIconProps> = ({ testId }) => (
  <IconWrapper data-testid={testId}>
    <RequestTitleIcon />
  </IconWrapper>
);

export default RequestIcon;
